module.exports = __webpack_public_path__ + "src/assets/img/04.3a1d40b3.png";